import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const HomePageText = () => {
  const [appear, setAppear] = useState(false);
  const [appearbtn, setAppearbtn] = useState(false);
  const homeTextRef = useRef();

  const handleScroll = () => {
    var top = window.pageYOffset;

    var introOffset;
    if (window.innerWidth < 450)
      introOffset = homeTextRef.current.offsetTop - window.innerHeight + 320;
    else introOffset = homeTextRef.current.offsetTop - window.innerHeight + 380;

    if (top >= introOffset) setAppear(true);
    else setAppear(false);

    if (top >= introOffset + 70) setAppearbtn(true);
    else setAppearbtn(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div ref={homeTextRef} className={appear ? 'one-text' : 'one-text hide'}>
      <br className='hide-col' />
      <br className='hide-col' />
      <p>
        Our vision is to craft the brands and choice of drinks that people love,
        to refresh them in body and spirit. And done in ways that create a more
        sustainable business and better shared future that makes a difference in
        people’s lives, communities and our planet.
      </p>

      <div className='overflow-hide'>
        <Link to='/ourstory'>
          <button className={appearbtn ? '' : 'hide-btn'}>Our Story</button>
        </Link>
      </div>
    </div>
  );
};

export default HomePageText;
